export default "__VITE_ASSET__CdnXOdJL__"